import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAppRoomType } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getAppRoomTypeList = (data: IDynamicTableParams) => {
  return instance()
    .post<IAppRoomType[]>('/app/roomType/list', data)
    .then((response) => response.data);
};

export const getAppRoomTypeListAll = () => {
  return instance()
    .post<IAppRoomType[]>('/app/roomType/listAll')
    .then((response) => response.data);
};

export const getAppRoomTypeAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/app/roomType/availableColumns')
    .then((response) => response.data);
};

export const getAppRoomTypeAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/app/roomType/availableGroupColumns')
    .then((response) => response.data);
};

export const loadAppRoomType = (appRoomTypeId: number) => {
  return instance()
    .get<IAppRoomType>(`/app/roomType/load/${appRoomTypeId}`)
    .then((response) => response.data);
};

export const createAppRoomType = (appRoomType: IAppRoomType) => {
  return instance()
    .post<IAppRoomType>(`/app/roomType/save`, appRoomType)
    .then((response) => response.data);
};

export const updateAppRoomType = (appRoomType: IAppRoomType) => {
  return instance()
    .post<IAppRoomType>(`/app/roomType/${appRoomType.roomTypeId}/update`, appRoomType)
    .then((response) => response.data);
};

export const archiveAppRoomType = (roomTypeId: number) => {
  return instance()
    .post('/app/roomType/archive', { roomTypeId })
    .then((response) => response.data);
};

export const recoverAppRoomType = (roomTypeId: number) => {
  return instance()
    .post('/app/roomType/recover', { roomTypeId })
    .then((response) => response.data);
};
